"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCorrectedTotalsSchema = exports.correctedTotalSchema = exports.versionEntrySchema = exports.editorRoleSchema = exports.createOSPCorrectedTotalsSchema = exports.newCorrectedTotalSchema = void 0;
const zod_1 = require("../zod");
const DayTime_schema_1 = require("./common/DayTime.schema");
exports.newCorrectedTotalSchema = zod_1.z.object({
    date: DayTime_schema_1.dayTimeSchema,
    total: zod_1.z.coerce.number(),
    offeredReportId: zod_1.z.coerce.number().nullish(),
    workingUnitLocationId: zod_1.z.coerce.number().nullish(),
    released: zod_1.z.coerce.boolean().nullish(),
    releaseDate: zod_1.z.coerce.date().nullish(),
});
exports.createOSPCorrectedTotalsSchema = zod_1.z.object({
    workingUnitLocation: zod_1.z.coerce.number().int().positive(),
    totalsToCreate: zod_1.z.array(exports.newCorrectedTotalSchema),
});
// Editor role - TEF (Telefonica) or OSP (Service Provider)
exports.editorRoleSchema = zod_1.z.enum(['TEF', 'OSP']);
// Version entry for tracking edit history
exports.versionEntrySchema = zod_1.z.object({
    userId: zod_1.z.number(),
    role: exports.editorRoleSchema,
    value: zod_1.z.number(),
    previousValue: zod_1.z.number().nullable().optional(),
    date: zod_1.z.string(),
    draft: zod_1.z.boolean().optional(),
});
exports.correctedTotalSchema = zod_1.z.object({
    id: zod_1.z.coerce.number().int().positive(),
    offeredReportId: zod_1.z.coerce.number().int().positive(), // Required to match database model
    date: DayTime_schema_1.dayTimeSchema,
    value: zod_1.z.coerce.number().nullable(),
    workingUnitLocation: zod_1.z.coerce.number().int().positive(),
    // Version tracking fields (optional for backwards compatibility)
    versions: zod_1.z.array(exports.versionEntrySchema).nullable().optional(),
    lastEditedByRole: exports.editorRoleSchema.nullable().optional(),
    isTefCreated: zod_1.z.boolean().optional(),
    // Release state, read-only on responses. The update endpoint only writes `value` and derives
    // release state from the DB record, so these are ignored on input. Exposed so consumers can
    // tell genuine drafts (no releaseDate) from legacy released rows (released=false but releaseDate
    // set), which the sticky-released read (CALL-742) counts as released.
    released: zod_1.z.coerce.boolean().nullish(),
    releaseDate: zod_1.z.coerce.date().nullish(),
});
exports.updateCorrectedTotalsSchema = zod_1.z.array(exports.correctedTotalSchema).nonempty();
